import Typography from '@mui/material/Typography'
import { useSearchParams } from 'react-router-dom'
import { ConfirmDialogWrapper } from '../../components/ConfirmDialogWrapper'
import { useAssistantAdministrationStore } from '../../store/storeAssistantAdministration'

export const RecordArchiveDialog = ({ open, handleClose, record }) => {
    const [searchParams, setSearchParams] = useSearchParams()

    const { archiveRecord, isLoadingArchiveRecord } = useAssistantAdministrationStore(
        (state) => state,
    )

    const handleClickArchive = async () => {
        await archiveRecord({ recordId: record.id }, { is_archived: !record.is_archived })
        searchParams.set('is_archived', !record.is_archived ? 'true' : 'false')
        searchParams.set('offset', 0)
        await setSearchParams(searchParams)
        handleClose()
    }

    return (
        <ConfirmDialogWrapper
            open={open}
            handleSubmit={handleClickArchive}
            handleClose={handleClose}
            title={record.is_archived ? 'Вернуть запись из архива?' : 'Архивировать запись?'}
            submitButtonText={record.is_archived ? 'Разархивировать' : 'Архивировать'}
            isDisabled={isLoadingArchiveRecord}>
            <Typography variant="body1">
                {record.is_archived ? (
                    <>
                        Запись будет восстановлена. <br />
                    </>
                ) : (
                    <>
                        Запись будет перенесена в Архивированные записи. Вы сможете восстановить ее
                        в любое время
                    </>
                )}
            </Typography>
        </ConfirmDialogWrapper>
    )
}
